import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { slidesToolActivityDescribers } from "../slides/slides-tool-activity-describers";
import { gpuToolActivityDescribers } from "../gpu/gpu-tool-activity-describers";
import { model3dToolActivityDescribers } from "../model3d/model3d-tool-activity-describers";
import { shaderToolActivityDescribers } from "../shader/shader-tool-activity-describers";
import { videoToolActivityDescribers } from "./video-tool-activity-describers";

export const labsToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  ...slidesToolActivityDescribers,
  ...videoToolActivityDescribers,
  ...model3dToolActivityDescribers,
  ...shaderToolActivityDescribers,
  ...gpuToolActivityDescribers,
];
